/** Authenticated chat home — HomePage route in App.tsx. */
export const HOME_PATH = "/home";

/** True when the user is on the chat home surface (incl. legacy `/` redirect). */
export function isHomePath(pathname: string): boolean {
  return pathname === "/" || pathname === HOME_PATH;
}
